import { getCurrentCountryConfig } from "@/countries";

export const stringToFloat = (value: string): number => {
  const { decimalSeparator } = getCurrentCountryConfig();
  return parseFloat(value.replace(decimalSeparator, "."));
};

export const isStringNumber = (value: any): boolean => {
  const { decimalSeparator } = getCurrentCountryConfig();
  return !isNaN(value.replace(decimalSeparator, "."));
};

export const numberToLocaleStringFormat = (
  value: number | null | undefined,
  fixedDecimals: number
): string => {
  const { decimalSeparator } = getCurrentCountryConfig();
  // Round first, then normalise the result with `|| 0`. Tiny negative values
  // (and NaN) would otherwise be rendered as "-0,00".
  const rounded = Number((value ?? 0).toFixed(fixedDecimals)) || 0;
  return rounded.toFixed(fixedDecimals).replace(".", decimalSeparator);
};

export { formatEmploymentRatePercent } from "./employmentRate";

export const minutesFromHoursMinutesDecimal = (hoursMinutesDecimals: number): number => {
  const minutesWithDecimals = (hoursMinutesDecimals % 1) * 60;
  const minutes = Math.round((minutesWithDecimals + Number.EPSILON) * 100) / 100;
  return Math.round(minutes);
};

export const weekAverageInHoursMinutesFormat = (
  averagePerDayInDecimals: number,
  daysCount: number = 5
): string => {
  const minutes = minutesFromHoursMinutesDecimal(averagePerDayInDecimals);
  const hours = Math.floor(averagePerDayInDecimals);
  const minTimesDays = minutes * daysCount;
  const hoursX = Math.floor(minTimesDays / 60);
  const hoursPerWeek = hours * daysCount + hoursX;
  const minutesPerWeek = minTimesDays - hoursX * 60;
  //'0' + slice(-2) padder tal med 0 hvis de er mellem 0-9.
  return (
    ("0" + hoursPerWeek).slice(-2) +
    ":" +
    ("0" + (minutesPerWeek === 60 ? 0 : minutesPerWeek)).slice(-2)
  );
};
